module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/headers-styles.component.scss
// module id = ./src/app/features/headers-styles/headers-styles.component.scss
// module chunks = main